import React from 'react';

import PropTypes from 'prop-types';
import {
  geoMercator,
  geoPath,
  geoCentroid,
  geoBounds,
  geoDistance,
} from 'd3-geo';
import { select } from 'd3-selection';
import 'd3-transition';

class Mapa extends React.Component {
  static propTypes = {
    shape: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    item: PropTypes.object,
    onSelect: PropTypes.func,
    keyProperty: PropTypes.string,
    title: PropTypes.func,
    fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    stroke: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  };

  static defaultProps = {
    fill: '#ddd',
    stroke: '#000',
    strokeWidth: 1,
  };

  state = {
    shape: { features: [] },
    selected: null,
  };

  componentWillReceiveProps(props) {
    let { shape, selected } = props;
    if (this.state.selected !== selected) {
      this.setState({ selected });
    }
    if (this.state.shape !== shape) {
      this.setState({ shape });
    }
  }

  select(d) {
    let { onSelect } = this.props;
    if (onSelect) {
      onSelect(d);
    }
  }

  render() {
    let { shape, selected } = this.state;
    let {
      keyProperty,
      title,
      fill,
      stroke,
      strokeWidth,
      onMouseEnter,
      onMouseOut,
    } = this.props;
    let width = window.innerWidth - 285;
    let height = window.innerHeight - 128;
    console.log(width + 'x' + height);
    if (shape.type) {
      let translate = [width / 2.5, height / 1.95];
      let bounds = geoBounds(shape),
        center = geoCentroid(shape);
      let distanceX = geoDistance(bounds[0], [bounds[0][0], bounds[1][1]]),
        distanceY = geoDistance(bounds[0], [bounds[1][1], bounds[0][0]]),
        scale = Math.max(width / distanceX, height / distanceY) / 2.5;
      this.projection = () =>
        geoMercator()
          .center(center)
          .translate(translate)
          .scale(scale);
      let node = select(this.g);
      let transform = '';
      if (selected) {
        let point = geoPath()
          .projection(this.projection())
          .centroid(selected);
        transform = `translate(${translate})scale(3)translate(${-point[0]}, ${-point[1]})`;
      }
      node
        .transition()
        .duration(750)
        .attr('transform', transform);
    }

    return (
      <svg width={width} height={height}>
        <g
          className="features"
          style={{ cursor: 'pointer' }}
          ref={ref => (this.g = ref)}
        >
          {shape.features.map((d, i) => (
            <path
              id={d.properties[keyProperty]}
              key={d.properties[keyProperty]}
              d={geoPath().projection(this.projection())(d)}
              className="feature"
              fill={typeof fill === 'function' ? fill(d, i) : fill}
              stroke={typeof stroke === 'function' ? stroke(d, i) : stroke}
              strokeWidth={
                typeof strokeWidth === 'function'
                  ? strokeWidth(d, i)
                  : strokeWidth
              }
              onClick={() => this.select(d)}
              onMouseEnter={e => {
                if (onMouseEnter) {
                  onMouseEnter(d, i, e);
                }
              }}
              onMouseOut={e => {
                if (onMouseOut) {
                  onMouseOut(d, i, e);
                }
              }}
            >
              {title ? <title>{title(d, i)}</title> : ''}
            </path>
          ))}
        </g>
      </svg>
    );
  }
}

export default Mapa;



// WEBPACK FOOTER //
// ./src/components/mapas/Mapa.js